var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.3712 18.6276 0 12 0C5.3724 0 0 5.3712 0 12C0 18.6264 5.3724 24 12 24C18.6276 24 24 18.6264 24 12Z",
    fill: "#E8EAF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0434 11.2427C13.0434 10.6643 12.5718 10.1927 11.9934 10.1927C11.415 10.1927 10.9434 10.6643 10.9434 11.2427V16.5467C10.9434 17.1251 11.415 17.5967 11.9934 17.5967C12.5718 17.5967 13.0434 17.1251 13.0434 16.5467V11.2427ZM10.9504 7.43539C10.9504 8.01379 11.4196 8.48539 11.9944 8.48539C12.586 8.48539 13.0564 8.01379 13.0564 7.43539C13.0564 6.85699 12.586 6.38539 12.0064 6.38539C11.4244 6.38539 10.9504 6.85699 10.9504 7.43539Z",
    fill: "#737FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.c61632ad.svg";
export { ForwardRef as ReactComponent };